module.exports = __webpack_public_path__ + "media/bundles/ReactHome/components/layout/images/slide1-afe180e9bb9db962fb3a42521c326c1e.jpg";